import { Directive } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ModalDismissRoleEnum } from 'src/app/task-process/answer-editor/send-and-popover/modal-dismiss-role.enum';

@Directive()
export abstract class AbstractModalWithResult<T> {
  constructor(private popoverController: PopoverController) {}

  abstract getModalId(): string;

  ok(result: T) {
    this.popoverController.dismiss(result, ModalDismissRoleEnum.OK, this.getModalId());
  }

  cancel() {
    this.popoverController.dismiss(null, ModalDismissRoleEnum.Cancel, this.getModalId());
  }
}
